<template>
  <input
    :id="getId()"
    :value="value"
    class="form-control"
    type="email"
    :disabled="disabled"
    @input="onInput($event.target.value)"
    @blur="validate"
  />
</template>

<script>
import Field from './Field.vue';

export default {
  extends: Field,
  data() {
    return {
      validationRules: ['email']
    };
  }
};
</script>
